export const groupBy = <T>(array: T[], key: string): Record<string, T[]> =>
  array.reduce(
    (groupedObject, currentItem) => {
      const keyValue = currentItem[key as keyof T] as string;
      const group = groupedObject[keyValue] ?? [];
      group.push(currentItem);
      groupedObject[keyValue] = group;
      return groupedObject;
    },
    {} as Record<string, T[]>
  );
